import React, { Component } from 'react';
import { Button, Row } from 'antd';
import 'antd/dist/antd.css';
import PropTypes from 'prop-types';

import QuestionView from './QuestionView';
import i18n from '../../config/i18n';

class QuestionsReviewView extends Component {
  static propTypes = {
    answers: PropTypes.arrayOf(PropTypes.shape({})),
    nextPhase: PropTypes.func.isRequired,
    previousPhase: PropTypes.func.isRequired,
    showConfirmMessage: PropTypes.bool,
  };

  static defaultProps = {
    answers: [],
    showConfirmMessage: true,
  };

  constructor(props) {
    super(props);
    const { answers } = this.props;
    this.state = {
      answers,
    };
  }

  getQuestionView = (questions, index, disableInput, answerSet) => (
    <QuestionView
      item={questions[index]}
      index={index}
      save={() => { }} // do nothing for saving
      key={index}
      savedAnswers={answerSet}
      disableInput={disableInput}
    />
  );

  getReviewView = (questions, resumeAnswerSet) => questions.map(
    (item, index) => this.getQuestionView(questions, index, true, resumeAnswerSet)
  );

  render() {
    const {
      questionSet,
      resumeAnswerSet,
      nextPhase,
      previousPhase,
      disableNavButtons,
      showConfirmMessage,
    } = this.props;
    return (
      <div>
        <h3>
          {showConfirmMessage ? i18n.t('confirmAnswers') : null}
        </h3>
        <div>
          {this.getReviewView(questionSet, resumeAnswerSet)}
        </div>
        {!disableNavButtons
          ? (
            <div><br />
              <Row type="flex" justify="space-between">
                <Button
                  type="primary"
                  size={'large'}
                  onClick={previousPhase}
                >
                  {i18n.t('backButton')}
                </Button>
                <Button
                  type="primary"
                  size={'large'}
                  onClick={nextPhase}
                >
                  {i18n.t('nextButton')}
                </Button>
              </Row>
            </div>)
          : null}
      </div>
    );
  }
}

export default QuestionsReviewView;



// WEBPACK FOOTER //
// ./src/components/fpp/QuestionsReviewView.js